module.exports = __webpack_public_path__ + "media/images/bhima_thankyou-15c9d597e23b50c4616fe1d5e176be2a.svg";